var Curriculog = Curriculog || {};

Curriculog.ApFilter = (function ($, _, Backbone, ApFilter) {

	ApFilter = Curriculog.DropdownFilterView.extend({
		events: {
			'change': 'apChanged'
		},

		getSelectedValue: function () {
			var apID = this.params.queryParams.get(this.filterParam.ap),
			    apType = this.params.queryParams.get(this.filterParam.type);

			// Type and ap share the same dropdown with different optgroups so
			// check if type was selected before assuming ap id
			if (apType || apID) {
				if (apType) {
					return apType;
				}

				return apID;
			}

			return '';
		},

		getNewSelectedValue: function () {
			var value = this.$el.val();

			/*
			 * If we are loading the params from a localStorage session,
			 * bypass the value check since the value will already be set
			 * at the point which the apChanged method is called
			 *
			 * Otherwise, test whether the new value and the param value are the same,
			 * if so, do not modify the current step filter.
			 *
			 * Also, since the possible value can be either str or int,
			 * always cast the result of getSelectedValue to str so that we
			 * can correctly test equivalency
			 *
			 */
			if (this.params.paramsLoadedFromSession || this.getSelectedValue().toString() !== value) {
				var valueType = 'all';

				if (value) {
					valueType = isNaN(value) ? 'type' : 'apid';
				}

				return {'value': value, 'type': valueType};
			}

			return {};
		},

		set: function () {
			var value = this.$el.val(),
			    apID = 0,
			    apType = '';

			if (_.indexOf(['course','program','other'], value) !== -1) {
				apType = value;
			} else {
				apID = +value;
			}

			this.params.queryParams.set(this.filterParam.type, apType);
			this.params.queryParams.set(this.filterParam.ap, apID);
		},

		buildDropdown: function (collection, value) {
			var attributes = {},
			    approvalProcessTypes = {
					course: 'Course',
					program: 'Program',
					other: 'Other',
			    };

			this.getDropdownAttributes(attributes);

			var dropdown = new Curriculog.ApprovalProcessDropdownView({
				collection: collection ? collection : {},
				approvalProcessTypes: approvalProcessTypes,
				attributes: attributes,
				firstOption: this.firstOption,
				noAvailableOptionsMessage: this.noAvailableOptionsMessage,
				selectedValue: (isNaN(value) ? value : parseInt(value)),
			});

			this.replaceDropdownDomElement(dropdown, value);
		},

		apChanged: function () {
			Backbone.trigger('ap:change', this.getNewSelectedValue());

			// Set the option so that we can correctly test whether the newly selected option was the original selected option or not
			this.set();
		}

	});

	return ApFilter;

})($, _, Backbone, Curriculog.ApFilter || {});